module.exports = __webpack_public_path__ + "img/1478167172.4d638136.jpg";